import React from "react";

import Grid from "@mui/material/Grid";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";

const FormButtons = (props) => {
  const { type, resetFunction } = props;

  const buttonText = type === "edit" ? "Update" : "Submit";

  return (
    <Grid item xs={12}>
      <Box sx={{ display: "flex", alignItems: "center" }}>
        <Button size="medium" type="submit" variant="contained" sx={{ mr: 3 }}>
          {buttonText}
        </Button>
        {type === "edit" ? null : (
          <Button
            size="medium"
            variant="outlined"
            color="secondary"
            onClick={resetFunction}
          >
            Reset
          </Button>
        )}
      </Box>
    </Grid>
  );
};

FormButtons.defaultProps = {
  type: "",
  cancelFunction: () => {},
};

export default FormButtons;
